import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Button, Form } from 'reactstrap';
import { connect } from 'react-redux';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import FormFooter from '../../../common/forms/FormFooter';
import MultiPaymentMethodInputGroup, {
  isPinpadLocked,
} from '../../../common/forms/MultiPaymentMethodInputGroup';
import { clearCreditNotes, getCreditNotes } from '../../../../actions';
import {
  PAYMENT_METHOD_PAGO_EN_DESTINO,
  PAYMENT_METHOD_BUSINESS_CREDIT,
  TRANSACTION_TYPE_OTHER,
} from '../../../../config/constants';
import { numberFormatter } from '../../../../utils/number';

const PayParcelForm = ({
  handleSubmit,
  handleProcess,
  parcel,
  pendingAmount,
  onCancel,
  saving,
  pinpadLocked,
  dispatchGetCreditNotes,
  dispatchClearCreditNotes,
}) => {
  useLayoutEffect(() => {
    let query = null;
    if (parcel.business && parcel.business.id) {
      query = [`businessId:${parcel.business.id}`];
    } else if (parcel.customer && parcel.customer.id) {
      query = [`customerId:${parcel.customer.id}`];
    }

    if (query) {
      dispatchGetCreditNotes({
        query: [...query, 'isValid:true', 'previousParcelId:!Ø'],
      });
    }

    return () => {
      dispatchClearCreditNotes();
    };
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(handleProcess)}>
        <ResourceProperty label="Serie:">
          {parcel.documentSeries}
        </ResourceProperty>
        <ResourceProperty label="Número de serie:">
          {parcel.documentCode}
        </ResourceProperty>
        <ResourceProperty label="Origen:">
          {parcel.sourceCityName}
        </ResourceProperty>
        <ResourceProperty label="Destino:">
          {parcel.destinationCityName}
        </ResourceProperty>
        <ResourceProperty label="Monto pendiente:">
          {numberFormatter({ style: 'currency', value: pendingAmount })}
        </ResourceProperty>
        <hr />
        <MultiPaymentMethodInputGroup
          formName="PayParcelForm"
          totalPrice={pendingAmount}
          transactionCodesNotIncluded={[
            PAYMENT_METHOD_PAGO_EN_DESTINO,
            PAYMENT_METHOD_BUSINESS_CREDIT,
            TRANSACTION_TYPE_OTHER,
          ]}
        />
        <FormFooter
          saveButtonColor="secondary"
          saveButtonIcon="fa fa-money"
          saveButtonText="Pagar"
          saveButtonDisabled={saving || pinpadLocked}
        >
          <Button color="primary" onClick={onCancel} disabled={saving}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

PayParcelForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  parcel: PropTypes.shape({
    documentSeries: PropTypes.string,
    documentCode: PropTypes.string,
    sourceCityName: PropTypes.string,
    destinationCityName: PropTypes.string,
    customer: PropTypes.shape({ id: PropTypes.number }),
    business: PropTypes.shape({ id: PropTypes.number }),
  }).isRequired,
  pendingAmount: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  pinpadLocked: PropTypes.bool.isRequired,
  dispatchGetCreditNotes: PropTypes.func.isRequired,
  dispatchClearCreditNotes: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  saving: Boolean(state.CargoUnit.Cargo.getIn(['all', 'loading'])),
  pinpadLocked: isPinpadLocked('PayParcelForm')(state),
});

const mapDispatchToProps = {
  dispatchGetCreditNotes: getCreditNotes,
  dispatchClearCreditNotes: clearCreditNotes,
};

const formComponent = reduxForm({
  form: 'PayParcelForm',
})(PayParcelForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
